import { render, staticRenderFns } from "./GenericFaqQuestions.vue?vue&type=template&id=881cbb3e&scoped=true"
import script from "./GenericFaqQuestions.vue?vue&type=script&lang=js"
export * from "./GenericFaqQuestions.vue?vue&type=script&lang=js"
import style0 from "./GenericFaqQuestions.vue?vue&type=style&index=0&id=881cbb3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881cbb3e",
  null
  
)

export default component.exports